/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_Own_DataInputs */

const da_forside_example_own_data = /** @type {(inputs: Forside_Example_Own_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til egne data? Opret en klasse med elevnumre, og start en ny prøve med jeres egen rettevejledning.`)
};

/** @type {(inputs: Forside_Example_Own_DataInputs) => LocalizedString} */
const en_forside_example_own_data = da_forside_example_own_data;

/**

* @param {Forside_Example_Own_DataInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_own_data = /** @type {((inputs?: Forside_Example_Own_DataInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Own_DataInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_own_data(inputs)
	return /** @type {LocalizedString} */ ("Klar til egne data? Opret en klasse med elevnumre, og start en ny prøve med jeres egen rettevejledning.")
});